/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { HtmlPage } from '../../../widgets/landing-page-widget';
import { VerifySuccessPageService } from '../../../services';
import { VApplication } from '../../../application';
import { useTheme } from '../../../providers/theme';
import { useSMVerifyProductPage } from '../machines/pageContent';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import MiddleBlock from '../components/MiddleBlock';
import Image from 'react-bootstrap/Image';
import { useLocation } from 'react-router-dom';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.VerifySuccessPageService'
  ) as VerifySuccessPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const location = useLocation();
  const { width, height, bp } = useViewport();
  const staticPageContentConfig = srv?.getStaticPageContent();
  const [buttonItem, setButtonItem] = useState();

  const { verifyProductPageState } = useSMVerifyProductPage({});
  const content = staticPageContentConfig?.CONTENT;
  return (
    <>
      <div className='bubble' />
      <div className='bottomBubble' />
      <div className='bottomRectangle' />
      <div className='container' />
      <div className='headerLogoContainer'>
        <Image
          src={'https://i.ibb.co/8dmDZGB/trag-text-logo.png'}
          width={'30%'}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: height - 62,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '5%',
          }}
        >
          <MiddleBlock
            title={content.title}
            content={content.text}
            button={content.button}
            onClick={props?.onClick}
            section={content.section}
            id={content.id}
            scrollTo={content.scrollTo}
            key={`landing-page-middle`}
            link={content.link}
            color={props.color}
            secondaryColor={props.secondaryColor}
            onFocusColor={props?.onFocusColor}
            titleStyle={content.titleStyle}
            contentStyle={content.contentStyle}
            buttonPrimaryColor={content.buttonPrimaryColor}
            buttonSecondaryColor={content.buttonSecondaryColor}
            buttonFocusColor={content.buttonFocusColor}
          />
          <img src={'https://i.ibb.co/6WGSfK6/tick.png'} width={'40%'} />
          <div
            style={{
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '18px',
              paddingBottom: '10px',
            }}
          >
            Enjoy Responsibly. Don't drink and Drive.
          </div>
          {location?.state?.image ? (
            <img
              src={location?.state?.image}
              alt={content.text}
              width={'80%'}
              height={height * 0.3}
              style={{ objectFit: 'contain' }}
            />
          ) : (
            <div style={{ height: height * 0.3 }} />
          )}
        </div>
      </div>
    </>
  );
};
